import { render } from "./TableComponent.vue?vue&type=template&id=7b07dc60&scoped=true"
import script from "./TableComponent.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./TableComponent.vue?vue&type=script&charset=utf-8&lang=js"

import "./TableComponent.vue?vue&type=style&index=0&id=7b07dc60&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b07dc60"]])

export default __exports__